import { render, staticRenderFns } from "./side_contact.vue?vue&type=template&id=12f9afe2&scoped=true&"
import script from "./side_contact.vue?vue&type=script&lang=js&"
export * from "./side_contact.vue?vue&type=script&lang=js&"
import style0 from "./side_contact.vue?vue&type=style&index=0&id=12f9afe2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9afe2",
  null
  
)

export default component.exports